import { NavLink, Outlet } from 'react-router-dom';
import { User, Shield, Users, KeyRound } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/portal/settings/profile', label: 'Profile', icon: User },
  { to: '/portal/settings/security', label: 'Security', icon: Shield },
  { to: '/portal/settings/team', label: 'Team', icon: Users },
  { to: '/portal/settings/login-methods', label: 'Login methods', icon: KeyRound },
];

export function PortalSettingsLayout() {
  return (
    <div className="space-y-6">
      <nav className="flex gap-1 border-b border-border-subtle pb-0">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 -mb-px transition-colors',
                isActive
                  ? 'border-accent-cyan text-text-primary font-medium'
                  : 'border-transparent text-text-secondary hover:text-text-primary',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
